/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Answer_CorrectInputs */

const en_player_answer_correct = /** @type {(inputs: Player_Answer_CorrectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correct!`)
};

const ja_player_answer_correct = /** @type {(inputs: Player_Answer_CorrectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正解!`)
};

const fr_player_answer_correct = /** @type {(inputs: Player_Answer_CorrectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correct !`)
};

const de_player_answer_correct = /** @type {(inputs: Player_Answer_CorrectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Richtig!`)
};

/**
* | output |
* | --- |
* | "Correct!" |
*
* @param {Player_Answer_CorrectInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const player_answer_correct = /** @type {((inputs?: Player_Answer_CorrectInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Answer_CorrectInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_player_answer_correct(inputs)
	if (locale === "ja") return ja_player_answer_correct(inputs)
	if (locale === "fr") return fr_player_answer_correct(inputs)
	return de_player_answer_correct(inputs)
});